export const FEATURE_TYPES = [
    {type: "timekeeping", label: "Timekeeping", icon: "mdi-timer-outline"},
    {type: "forms", label: "Forms", icon: "mdi-clipboard-text-multiple-outline"},
];
export default FEATURE_TYPES
